export default function Marquee({ items, dark = false }) {
  const row = [...items, ...items];
  return (
    <div
      className={`overflow-hidden border-y py-5 ${dark ? "border-white/10 bg-navy-dark" : "border-slate-200/70 bg-sand"}`}
      aria-hidden="true"
      data-testid="editorial-marquee"
    >
      <div className="animate-marquee flex w-max items-center">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className={`font-display text-xl font-bold tracking-tight sm:text-2xl ${dark ? "text-white/40" : "text-navy/50"}`}>{item}</span>
            <span
              className={`mx-8 h-1.5 w-1.5 rounded-full ${
                ["bg-dot-red", "bg-dot-green", "bg-dot-blue", "bg-dot-amber"][i % 4]
              }`}
            />
          </span>
        ))}
      </div>
    </div>
  );
}
